module.exports = "pegasus/assets/roundrect-twitter.png";